import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=1b465b49&scoped=true&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"
import style0 from "./Component.vue?vue&type=style&index=0&id=1b465b49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b465b49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b465b49')) {
      api.createRecord('1b465b49', component.options)
    } else {
      api.reload('1b465b49', component.options)
    }
    module.hot.accept("./Component.vue?vue&type=template&id=1b465b49&scoped=true&", function () {
      api.rerender('1b465b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/Component.vue"
export default component.exports